import React from 'react';
import { useDispatch } from 'react-redux';

import GetMainHome from '@src/api/GetMainHome';
import { generateDynamicPageItem } from '@src/factories';
import useAxiosErrorHandler from '@src/hooks/useAxiosErrorHandler';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import { setHome as setHomeAction } from '@src/store/ui/actions';

const useRefreshHome = () => {
  const axiosRequestConfig = useAxiosRequestConfig();
  const axiosErrorHandler = useAxiosErrorHandler();
  const dispatch = useDispatch();

  const makeRequest = React.useCallback(async () => {
    try {
      const response = await GetMainHome(0, 20, axiosRequestConfig);
      if (response?.data) {
        dispatch(
          setHomeAction(
            response.data.items.map((item) => generateDynamicPageItem(item))
          )
        );
      }
    } catch (e) {
      axiosErrorHandler(e);
    }
  }, [axiosErrorHandler, axiosRequestConfig, dispatch]);

  React.useEffect(() => {
    makeRequest().catch(console.log);
  }, [makeRequest]);
};

export default useRefreshHome;
